import type { ReactNode } from 'react'

/**
 * Label de seção do protótipo chat-first: 10.5px, peso 650, uppercase,
 * tracking 0.1em, tinta baixa — AO VIVO / PRECISA DE VOCÊ / HOJE.
 */
export function SectionLabel({ children }: { children: ReactNode }) {
  return (
    <h2 className="flex items-center gap-2 text-[10.5px] font-semibold uppercase tracking-[0.1em] text-faint-foreground">
      {children}
    </h2>
  )
}
